module.exports = __webpack_public_path__ + "img/user.e9ace2e2.png";